import { formKeys } from './MCPServerConstants';

export const generateInitialValue = (mcpAppDetails) => {
    let initialValue = { [formKeys.basicDetails]: {}, [formKeys.attrCategory]: {} };

    if (!mcpAppDetails) {
        return {};
    }
    // Set basic details
    if (mcpAppDetails.basicDetails) {
        initialValue[formKeys.basicDetails] = {
            ...mcpAppDetails.basicDetails,
            category_id: mcpAppDetails.basicDetails?.MCPServerCategory?.category_id,
        };
    }

    // Set Logo Details
    if (mcpAppDetails.basicDetails && mcpAppDetails.basicDetails?.MCPServerLogo) {
        initialValue[formKeys.logo] = {
            mcp_server_logo_url: mcpAppDetails.basicDetails?.MCPServerLogo?.mcp_server_logo_url,
            fav_icon_logo_url: mcpAppDetails.basicDetails?.MCPServerLogo?.fav_icon_logo_url,
        };
    }

    if (mcpAppDetails.mcpResearchData) {
        mcpAppDetails.questionCategories.forEach((category) => {
            const categoryName = category.category_name;
            if (!category.multi_valued) {
                const question = category.questions.find((question) => {
                    const researchDataValue = mcpAppDetails.mcpResearchData[question.question_col_name];
                    if (researchDataValue === 'Yes') {
                        return true;
                    }
                    return false;
                });

                if (question) {
                    initialValue[formKeys.attrCategory][categoryName] = question.question_col_name;
                }
            } else {
                const questions = category.questions.filter((question) => {
                    const researchDataValue = mcpAppDetails.mcpResearchData[question.question_col_name];
                    if (researchDataValue === 'Yes') {
                        return true;
                    }
                    return false;
                });
                initialValue[formKeys.attrCategory][categoryName] = questions.map((question) => question.question_col_name);
            }
        });
    }
    console.log('initialValue', initialValue);
    return initialValue;
};

export const generateBasicDetails = (values) => {
    return values;
};

export const generateResearchData = (attributesValues, questionCategories) => {
    let researchData = {};
    questionCategories.forEach((category) => {

        const categoryValue = attributesValues[category.category_name];
        if (categoryValue) {
            category.questions.forEach((question) => {
                if (!category.multi_valued) {
                    researchData[question.question_col_name] = categoryValue === question.question_col_name ? 'Yes' : 'No';
                } else {
                    researchData[question.question_col_name] = categoryValue.includes(question.question_col_name) ? 'Yes' : 'No';
                }
            });
        }
    });

    console.log('researchData', researchData);
    return researchData;
};
